import "./cs-print.scss";
import { convertToJalaliWithTime, convertToJalaliWithoutTime, formatDate } from "../../../tools/tools";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
const CSPrint = ({ print, lang = "fa", canvas = false, value }) => {
  const formData = useSelector((state) => state?.another?._currentUser);
  const dispatch = useDispatch();
  const [language, setLanguage] = useState("");
  const [isCanvas, setIsCanvas] = useState(false);
  const myref = useRef("");
  useEffect(() => {
    setLanguage(lang);
    if (canvas) {
      setIsCanvas(true);
    }
  }, [print, lang, canvas]);
  useEffect(() => {
    if (isCanvas) {
      html2canvas(myref?.current).then((canvas) => {
        setTimeout(() => {
          const imgData = canvas.toDataURL("image/png");
          if (typeof value === "function") value(imgData); // Save the canvas image in the component's state
        }, 3000);
      });
    }
  }, [isCanvas]);
  return (
    <>
      <div ref={myref} className={`${isCanvas ? "canvas-document" : ""}`}>
        {language === "fa" ? (
          <div className="print-document-cp">
            <div className="header-doc border-row">
              <div className="row-doc">
                <div className="item-logo">
                  <img src={process.env.PUBLIC_URL + "/assets/images/logo-small.png"} alt="" />
                </div>
                <div className="item-title">
                  <div className="hold-title">
                    <h2>فرم تعویض سیم‌کارت</h2>
                  </div>
                </div>
                <div className="item-date">
                  تاریخ: <span dir="ltr">{convertToJalaliWithTime(new Date().toISOString())}</span>
                </div>
              </div>
            </div>
            <div className="under-header border-row">
              <p>
                احتراما اینجانب مشترک شرکت نگین ارتباطات آوا به مشخصات زیر ، به دلیل
                <label>
                  <input type="checkbox" /> سرقت
                </label>
                <label>
                  <input type="checkbox" /> مفقودی
                </label>
                <label>
                  <input type="checkbox" /> آسیب سیم کارت
                </label>{" "}
                <br />
                درخواست سیم کارت جایگزین دارم .
              </p>
            </div>
            <div className="holder-with-label border-row">
              <div className="item-block" data-content="درخواست کننده">
                <div className="item-block-prefix">
                  <span>درخواست کننده</span>
                </div>
                <div className="holder-list">
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">نام : </div>
                        <div className="value">{print?.stR_FName}</div>
                      </li>
                      <li>
                        <div className="label"> نام خانوادگی :</div>
                        <div className="value">{print?.stR_LName}</div>
                      </li>
                      <li>
                        <div className="label"> شماره مدرک شناسایی:</div>
                        <div className="value">{print?.stR_CertNo}</div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">کدپستی : </div>
                        <div className="value">{print?.address?.stR_PostalCode}</div>
                      </li>
                      <li>
                        <div className="label"> شماره تماس : </div>
                        <div className="value">{print?.inT_SMSMobileNo}</div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">آدرس دقیق (محل سکونت / تحویل سیم‌کارت) :</div>
                        <div className="value">
                          {print?.province?.stR_ProvinceName}, {print?.city?.stR_CityName}, {print?.address?.stR_MainStreet},{" "}
                          {print?.address?.stR_AuxiliaryRoad}, {print?.address?.stR_Alley}, {print?.address?.stR_BuildingNo},{" "}
                          {print?.address?.stR_Floor}, {print?.address?.stR_Unit}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="item-block" data-content="سیم‌کارت">
                <div className="item-block-prefix">
                  <span>سیم‌کارت</span>
                </div>
                <div className="holder-list">
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">شماره سیم کارت آپتل :</div>
                        <div className="value">{print?.msisdn}</div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="hold-row">
                          <div className="label">شماره کیت قدیم (در صورت وجود) :</div>
                          <div className="value"></div>
                        </div>
                        <br />
                        <div className="hold-row">
                          <div className="label">شماره کیت جدید (در صورت تحویل در محل) :</div>
                          <div className="value">
                            <span dir="ltr">{print?.kitno}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <div className="holder-place-deliver">
                      <div className="label">محل تحویل سیم کارت بسته بازگشت :</div>
                      <div className="otions">
                        <ul>
                          <li>
                            <div className="item">
                              <label htmlFor="">
                                <input type="checkbox" />
                                به آدرس مشترک ارسال گردد
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="item">
                              <label htmlFor="">
                                <input type="checkbox" />
                                در محل دریافت شد
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-block" data-content="اقرارنامه مفقودی/ سرقت">
                <div className="item-block-prefix">
                  <span>اقرارنامه مفقودی/ سرقت</span>
                </div>
                <div className="holder-list">
                  <div className="holder-item-row">
                    <div className="item-sign">
                      <strong>در صورت نبود پوکه سیم کارت قدیمی این بخش تکمیل گردد :</strong>
                      <p>
                        بدینوسیله گواهی می نمایم پوکه ، قاب ، و کلیه متعلقات مربوط به سیم کارت با اطالعات مندرج در این فرم مفقود گردیده است لذا چنانچه
                        خالف ادعادی اینجانب اثبات گردد ، شخصا پاسخگوی کلیه ادعاهای احتمالی مراجع دی صالح اعم از قضایی خواهم بود و شرکت نگین ارتباطات
                        آوا در این زمینه هیچگونه مسئولیتی نخواهد داشت .
                      </p>
                      <ul>
                        <li>
                          <div className="label"> تاریخ و امضاء مشترک :</div>
                          <div className="value"></div>
                        </li>
                        <li>
                          <div className="label"> اثر انگشت مشترک :</div>
                          <div className="value"></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hold-personal border-row">
              <p>
                اینجانب ........{formData?.firstname + " " + formData?.lastname}...... با نام کاربری ...........................{formData?.username}
                ............... بر اساس اطالعات مندرج در فرم هویت مشترک را تایید
                <br />
                مینمایم و هزینه های مربوط را وصول نموده ام .
              </p>
              <div className="holder-sign-cld">
                <p> مهر/ امضاء / تاریخ</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="print-document-cp" dir="ltr">
            <div className="header-doc border-row">
              <div className="row-doc">
                <div className="item-logo">
                  <img src={process.env.PUBLIC_URL + "/assets/images/logo-small.png"} alt="" />
                </div>
                <div className="item-title">
                  <div className="hold-title">
                    <h2>SIM SWAP FORM</h2>
                  </div>
                </div>
                <div className="item-date">
                  Date: <span dir="ltr">{formatDate(new Date().toISOString())}</span>
                </div>
              </div>
            </div>
            <div className="under-header border-row">
              <p>
                Respectfully, I am a subscriber of Negin Ertebatat Ava Company with the following specifications, I request a replacement SIM card
                <label>
                  <input type="checkbox" /> theft
                </label>
                <label>
                  <input type="checkbox" /> loss
                </label>
                <label>
                  <input type="checkbox" /> damage of the SIM Card.
                </label>{" "}
              </p>
            </div>
            <div className="holder-with-label border-row">
              <div className="item-block" data-content="Details of the applicant">
                <div className="item-block-prefix">
                  <span>Details of the applicant</span>
                </div>
                <div className="holder-list">
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">Name : </div>
                        <div className="value">{print?.stR_FName}</div>
                      </li>
                      <li>
                        <div className="label"> Last Name :</div>
                        <div className="value">{print?.stR_LName}</div>
                      </li>
                      <li>
                        <div className="label"> شماره مدرک شناسایی:</div>
                        <div className="value">{print?.stR_CertNo}</div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">Postal code : </div>
                        <div className="value">{print?.address?.stR_PostalCode}</div>
                      </li>
                      <li>
                        <div className="label"> fixed number : </div>
                        <div className="value">{print?.inT_SMSMobileNo}</div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">Exact address (place of residence / SIM card delivery):</div>
                        <div className="value">
                          {print?.province?.stR_ProvinceName}, {print?.city?.stR_CityName}, {print?.address?.stR_MainStreet},{" "}
                          {print?.address?.stR_AuxiliaryRoad}, {print?.address?.stR_Alley}, {print?.address?.stR_BuildingNo},{" "}
                          {print?.address?.stR_Floor}, {print?.address?.stR_Unit}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="item-block" data-content="SIM CARD">
                <div className="item-block-prefix">
                  <span>SIM CARD</span>
                </div>
                <div className="holder-list">
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="label">APTEL SIM Card NO :</div>
                        <div className="value">{print?.msisdn}</div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <ul>
                      <li>
                        <div className="hold-row">
                          <div className="label">Old KIT NO (If there are) :</div>
                          <div className="value"></div>
                        </div>
                        <br />
                        <div className="hold-row">
                          <div className="label">New KIT NO (In case of on-site delivery):</div>
                          <div className="value">
                            <span dir="ltr">{print?.kitno}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="holder-item-row">
                    <div className="holder-place-deliver">
                      <div className="label">Place of SIM SWAP Card delivery :</div>
                      <div className="otions">
                        <ul>
                          <li>
                            <div className="item">
                              <label htmlFor="">
                                <input type="checkbox" />
                                Be sent to the common address
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="item">
                              <label htmlFor="">
                                <input type="checkbox" />
                                Received on site
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-block" data-content="Statement of loss/thef">
                <div className="item-block-prefix">
                  <span>Statement of loss/thef</span>
                </div>
                <div className="holder-list">
                  <div className="holder-item-row">
                    <div className="item-sign">
                      <strong>If the old SIM Card is missing, complete this section :</strong>
                      <p>
                        I hereby certify that the cover, frame, and all accessories related to the SIM card included in this form are missing
                        information that can be proven against my claim. will not have any responsibility in this regard.
                      </p>
                      <ul>
                        <li>
                          <div className="label">Joint date and signature :</div>
                          <div className="value"></div>
                        </li>
                        <li>
                          <div className="label"> Joint fingerprint :</div>
                          <div className="value"></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hold-personal border-row">
              <p>
                I ........{formData?.firstname + " " + formData?.lastname}...... with the username...........................{formData?.username}
                ............... Based on the information contained in the form, I confirm the subscriber's identity and have collected the related
                fees
              </p>
              <div className="holder-sign-cld">
                <p> Date/Signature/Stamp</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CSPrint;
